import { formatCurrencyWhole } from '../../utils/formatCurrency';
import { Cell, DayIndicator, DayNumber, DayPrice } from './CalendarDay.styles';
import type { CalendarDayProps } from './CalendarDay.types';

export function CalendarDay({
  day,
  dateString,
  status,
  price,
  currencyCode,
  isCheckIn,
  isCheckOut,
  isInRange,
  isPast,
  isToday,
  isRangeStart,
  isRangeEnd,
  isRowStart,
  isRowEnd,
  isSelectingCheckOut,
  onClick,
}: CalendarDayProps) {
  if (!day || !dateString) {
    return <Cell data-empty disabled aria-hidden />;
  }

  const isSelected = isCheckIn || isCheckOut;
  const isBlocked =
    isPast ||
    status === 'unavailable' ||
    status === 'hotel_closed' ||
    (status === 'check_in_closed' && !isSelectingCheckOut);

  const showPrice =
    !isBlocked &&
    price !== undefined &&
    price > 0 &&
    currencyCode &&
    (status === 'available' || status === 'check_in_closed');

  const handleClick = () => {
    if (!isBlocked && onClick && dateString) {
      onClick(dateString);
    }
  };

  const isCheckInClosed =
    status === 'check_in_closed' && !isSelectingCheckOut && !isSelected && !isInRange;

  return (
    <Cell
      {...(isBlocked ? { 'data-blocked': '' } : undefined)}
      {...(isSelected ? { 'data-selected': '' } : undefined)}
      {...(isInRange && !isSelected ? { 'data-in-range': '' } : undefined)}
      {...(isRangeStart ? { 'data-range-after': '' } : undefined)}
      {...(isRangeEnd ? { 'data-range-before': '' } : undefined)}
      {...(isRowStart ? { 'data-row-start': '' } : undefined)}
      {...(isRowEnd ? { 'data-row-end': '' } : undefined)}
      {...(isToday && !isSelected && !isInRange ? { 'data-today': '' } : undefined)}
      {...(isCheckInClosed ? { 'data-check-in-closed': '' } : undefined)}
      {...(!isBlocked && !isSelected && day ? { 'data-hoverable': '' } : undefined)}
      onClick={handleClick}
      disabled={isBlocked}
      aria-label={`${dateString}${isCheckIn ? ', check-in' : ''}${isCheckOut ? ', check-out' : ''}`}
      type="button"
    >
      <DayIndicator>
        <DayNumber $selected={isSelected}>{day}</DayNumber>
        {showPrice && price !== undefined && currencyCode && (
          <DayPrice $selected={isSelected}>{formatCurrencyWhole(price, currencyCode)}</DayPrice>
        )}
      </DayIndicator>
    </Cell>
  );
}
